var Sub = require('@nichoth/events/subscribe');

var RequestSubscription = Sub.extend(function (sub) {
    // var evs = sub.evs;
    var evs = this.evs;
    this.on(evs.start, 'start')
        .on(evs.resolve, 'resolve')
        .on(evs.error, 'error');
});

module.exports = RequestSubscription;
